/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GenericSelect } from 'web-ui-components/lib/data/capture';
import withValidation from '../../../../containers/withValidation';
import { paymentTypeOptions } from '../../../../config/';
import withDescription from '../../../../containers/withDescription';
import { VisuallyHiddenBody } from 'web-ui-components/lib/typography/body';

class PaymentType extends Component {
	render() {
		const { id, handleSelectType, type, inputWrapClassName } = this.props;

		return (
			<div className={inputWrapClassName}>
				<label htmlFor={`field-type-${id}`}>
					<VisuallyHiddenBody>Payment Type</VisuallyHiddenBody>
				</label>
				<GenericSelect
					characterCount={8}
					id={`field-type-${id}`}
					items={paymentTypeOptions}
					onChange={handleSelectType}
					selectedId={type}
				/>
			</div>
		);
	}
}

PaymentType.propTypes = {
	id: PropTypes.string.isRequired,
	handleSelectType: PropTypes.func.isRequired,
	type: PropTypes.string.isRequired,
	onFocus: PropTypes.func.isRequired,
	onBlur: PropTypes.func.isRequired,
	disabled: PropTypes.bool.isRequired,
	inputWrapClassName: PropTypes.string.isRequired,
};

export { PaymentType };
export default withValidation({ validations: ['required'], key: 'type', message: 'Select a payment type' })(
	withDescription(PaymentType)
);
